import { AxiosResponse } from 'axios'
import api from 'src/services/api'
import { HistoricoEditarResponse } from './types'

export const obterHistoricoEdicao: (
  id: string
) => Promise<AxiosResponse<HistoricoEditarResponse[]>> = id => {
  return api.get(`/solicitacaoorcamento/${id}/historicoEdicao`)
}
